import { useMemo, useState } from 'react';
import './HelpPage.scss';
import { HelpCircle } from 'react-feather';
import { COLORS } from '../../../../utils/colors';
import { CaretDown, Play } from 'phosphor-react';
import { AppVideoModal } from '../../../general/AppVideoModal/AppVideoModal.';

const HELPDATA_SUPPLIER = [
  {
    id: 1,
    title: 'How do I sign the release on Dill?',
    video: 'JATtYp-JwoU',
  },
  {
    id: 2,
    title: 'What if there’s something wrong with the release on Dill?',
    video: 'Tu0OvNwBaB4',
  },
  {
    id: 3,
    title: 'How do I track and access all of my releases on Dill?',
    video: 'bTdtGSOnvB4',
  },
  {
    id: 4,
    title: 'What are these locked features on Dill?',
    video: '',
  },
];

const HELPDATA_BUYER = [
  {
    id: 1,
    title: 'Overview of Dill online portal',
    video: '-uXIsKVsq2A',
  },
  {
    id: 2,
    title: 'How do I switch between customer accounts?',
    video: 'RsPzrOVuohI',
  },
  {
    id: 3,
    title: 'How do I pay? What are the different ways I can pay?',
    video: 'IGGi91WGhHg',
  },
  {
    id: 4,
    title: 'How do I add a payment method on Dill?',
    video: 'QvbObQZo6i4',
  },
  {
    id: 5,
    title: 'I’m on early pay discount terms with my vendor. How do I use discounts?',
    video: 't6rXCo9BO-g',
  },
  {
    id: 6,
    title: 'How do I use credits on Dill?',
    video: 'Hd4woebZxUM',
  },
  {
    id: 7,
    title: 'How do I download my statements?',
    video: 'mL_5QjMbEck',
  },
  {
    id: 8,
    title: 'How do I deal with projects in here on Dill?',
    video: '-r6FYd5ki0s',
  },
  {
    id: 9,
    title: 'How do I add a team member for account access?',
    video: 'EcRmDCYHHaw',
  },
];
export const HelpPage = () => {
  const [selectAccountType] = useState(() => localStorage.getItem('selectAccountType'));
  const isSupplier = selectAccountType === 'Supplier';
  const helpData = useMemo(() => (isSupplier ? HELPDATA_SUPPLIER : HELPDATA_BUYER), [isSupplier]);
  const [openDropDown, setOpenDropDown] = useState(0);
  const [selectedVideo, setSelectedVideo] = useState('');
  const [openVideo, setOpenVideo] = useState(false);
  const handleOpen = (id: number) => {
    setOpenDropDown(id);
  };
  return (
    <div className="w-full h-[90%] p-8 overflow-scroll">
      <AppVideoModal
        open={openVideo}
        handleClose={() => setOpenVideo(false)}
        video={selectedVideo}
      />
      {helpData.map((item) => (
        <button
          className="help-item"
          key={`help_item_${item.id}`}
          onClick={() => handleOpen(item.id)}>
          <div className="row-container">
            <div className="detail-text">{item.title}</div>
            <CaretDown
              size={24}
              color={COLORS.GREY_600}
              style={{ rotate: openDropDown === item.id ? '180deg' : '0deg' }}
            />
          </div>
          {openDropDown === item.id && item.video !== '' && (
            <button
              className="video"
              onClick={() => {
                setOpenVideo(true);
                setSelectedVideo(item.video);
              }}>
              <iframe
                width="320"
                height="160"
                src={`https://www.youtube.com/embed/${item.video}`}
              />
              <div className="play-button">
                <Play size={24} color={COLORS.PRIMARY_500} />
              </div>
            </button>
          )}
          {openDropDown === item.id && item.video === '' && (
            <div className="sub-text">
              Locked features include a full platform that streamlines liens, lien waivers, and
              payments all in one. Other suppliers have used Dill to get paid faster and increase
              customer satisfaction. Reach out to customer support to learn more.
            </div>
          )}
        </button>
      ))}
      <div className="help-item">
        <div className="row-container">
          {isSupplier ? (
            <div className="detail-text">
              Call or text us at <span>(628) 304-0931</span> for customer support or feature
              requests
            </div>
          ) : (
            <div className="detail-text">
              Call us at <span>(628) 304-0931</span> or email <span>support@usedill.com</span> for
              customer support or feature requests
            </div>
          )}
          <div className="help-circle">
            <HelpCircle color={COLORS.WARNING_600} />
          </div>
        </div>
      </div>
    </div>
  );
};
